import { AmityUiKitChat } from '@frn/amityco-ui-kit-open-source';
import { Modal, ModalBody } from 'reactstrap';
import React, { useCallback, useEffect, useState } from 'react';

export default CoachChatModal = ({ isOpen = false }) => {
  const [_isOpen, setIsOpen] = useState(isOpen);
  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);
  const toggle = useCallback(() => {
    setIsOpen(!_isOpen);
  }, [_isOpen]);
  return (
    <Modal isOpen={_isOpen} toggle={toggle}>
      <div style={{ height: '95vh' }}>
        <AmityUiKitChat defaultChannelId="69f6352b6fa5aee61e82c88c" />
      </div>
    </Modal>
  );
};
